import React from "react";
import "./projectComponent.css";
import OptimizedSlideshow from './OptimizedSlideshow';
import image1 from "./images/NeoTM/image1.png";
import image2 from "./images/NeoTM/image2.png";
import image3 from "./images/NeoTM/image3.png";
import image4 from "./images/NeoTM/image4.png";
import image5 from "./images/NeoTM/image5.png";
import image6 from "./images/NeoTM/image6.png";
import image7 from "./images/NeoTM/image7.png";
import image8 from "./images/NeoTM/image8.png";
import image9 from "./images/NeoTM/image9.png";
import image10 from "./images/NeoTM/image10.png";
import image11 from "./images/NeoTM/image11.png";
import image12 from "./images/NeoTM/image12.png";
import image13 from "./images/NeoTM/image13.png";
import image14 from "./images/NeoTM/image14.png";
import image15 from "./images/NeoTM/image15.png";
import image16 from "./images/NeoTM/image16.png";
import image17 from "./images/NeoTM/image17.png";
import image18 from "./images/NeoTM/image18.png";
import image19 from "./images/NeoTM/image19.png";
import image20 from "./images/NeoTM/image20.png";
import image21 from "./images/NeoTM/image21.png";
import image22 from "./images/NeoTM/image22.png";
import image23 from "./images/NeoTM/image23.png";
import image24 from "./images/NeoTM/image24.png";
import image25 from "./images/NeoTM/image25.png";


const NeoTm = () => {
    const mediaItems = [
        {
            type: 'video',
            src: require('./images/NeoTM/Demo NeoTM.mp4'),
        },
        {
            type: 'image',
            src: image1,
        },
        {
            type: 'image',
            src: image2,
        },
        {
            type: 'image',
            src: image3,
        },
        {
            type: 'image',
            src: image4,
        },
        {
            type: 'image',
            src: image5,
        },
        {
            type: 'image',
            src: image6,
        },
        {
            type: 'image',
            src: image7,
        },
        {
            type: 'image',
            src: image8,
        },
        {
            type: 'image',
            src: image9,
        },
        {
            type: 'image',
            src: image10,
        },
        {
            type: 'image',
            src: image11,
        },
        {
            type: 'image',
            src: image12,
        },
        {
            type: 'image',
            src: image13,
        },
        {
            type: 'image',
            src: image14,
        },
        {
            type: 'image',
            src: image15,
        },
        {
            type: 'image',
            src: image16,
        },
        {
            type: 'image',
            src: image17,
        },
        {
            type: 'image',
            src: image18,
        },
        {
            type: 'image',
            src: image19,
        },
        {
            type: 'image',
            src: image20,
        },
        {
            type: 'image',
            src: image21,
        },
        {
            type: 'image',
            src: image22,
        },
        {
            type: 'image',
            src: image23,
        },
        {
            type: 'image',
            src: image24,
        },
        {
            type: 'image',
            src: image25,
        }
    ];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">NeoTm</h2>
        <span className="section__subtitle">AI-Powered QA Testing Platform</span>
        <OptimizedSlideshow mediaItems={mediaItems} />
        
        <div className="about__container container grid">
            <div className="text__container">
                <h3 className="title">Description:</h3>
                <br />
                <p className='redRadio__text'>
                    NeoTm is an advanced QA testing platform designed for comprehensive file comparison and quality assurance. 
                    Built to handle complex document analysis across multiple formats with AI-powered insights.
                </p>
                <br />
                
                <h4 className="title" style={{fontSize: '1.1rem', marginBottom: '0.5rem'}}>Core Capabilities</h4>
                <ul style={{listStyle: 'none', padding: '0', margin: '0'}}>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>📄 XML File Comparison</strong> - Intelligent analysis and comparison of XML document structures
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>📋 PDF Analysis</strong> - Advanced PDF content extraction and comparison capabilities
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🔧 MUT Integration</strong> - Seamless integration with Model Under Test frameworks
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🤖 AI-Powered QA</strong> - Machine learning algorithms, VLMs and Computer vision for automated quality assessment
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>📊 Detailed Reporting</strong> - Comprehensive test reports with actionable insights
                    </li>
                </ul>
                <br />
                
                <h4 className="title" style={{fontSize: '1.1rem', marginBottom: '0.5rem'}}>Platform Architecture</h4>
                <p className='redRadio__text'>
                    Enterprise-grade solution built with modern microservices architecture, featuring secure authentication, 
                    scalable document processing, and real-time comparison analytics.
                </p>
                <br />
                
                <p className='redRadio__text' style={{fontStyle: 'italic'}}>
                    Revolutionizing quality assurance through intelligent document comparison and AI-driven testing insights.
                </p>
            </div>

            <div className="skills__container1 container grid">
        <div className="skills__content">
        <h3 className="skills__title">Technologies Used</h3>

        <div className="skills__box">

        <div className="skills__group">

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Angular</h3>
                <span className="skills__level">Frontend</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">SpringBoot</h3>
                <span className="skills__level">Backend</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Python</h3>
                <span className="skills__level">Processing</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">MongoDB</h3>
                <span className="skills__level">Database</span>
            </div>
            </div>
        </div>

        <div className="skills__group">
            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">Keycloak</h3>
                <span className="skills__level">Auth</span>
              </div>
            </div>

            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">Jira</h3>
                <span className="skills__level">Methodology</span>
              </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">ML/DL</h3>
                <span className="skills__level">AI</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Gitlab</h3>
                <span className="skills__level">Collaboration</span>
            </div>
            </div>
          
        </div>

        </div>
    </div>
            </div>
        </div>
    </section>
    );
};

export default NeoTm;